const apiUrls = {
    //getContactPermissionsDetailsUrl: "api/user/GetContactPermissionsDetails/",
    //getErrorMessageUrl: "api/user/GetErrorMessage/",
    GetUserDetailsByAccountIdUrl: "api/User/GetUserDetailsByAccountId/",
    //VerifySearchUserByEmailUrl: "api/user/VerifyIfUserEmailExists/",
    //GetContactPermissionsDetailsUrl: "api/user/GetContactPermissionsDetails/",
    GetAdfsUserStatusUrl: "api/user/GetAdfsUserStatus/",
    UpdateUserPermissionUrl: "api/User/UpdateUserPermission",
    ConfirmAndSaveUserUrl: "api/User/ConfirmAndSaveUser",
    CreateUserUrl: "api/User/CreateUser",
    UpdateUserUrl: "api/User/UpdateUser",
    GetAccessibleApplicationsUrl: "api/user/GetAccessibleApplications/",
    EnableCustomerCommunity: "api/user/EnableCustomerComunityAccess/",
    GetAccountContactRolesByAccountIdUrl: "api/user/GetAccountContactRolesByAccountId/",
    GetAllPermissionsUrl: "api/user/GetAllPermissions/",
    //GetUserPermissionsUrl: "api/user/GetUserPermissions/",
    //GetRelatedAccountsBySfContactIDUrl: "api/User/GetRelatedAccountsBySfContactID/",
    RemoveAccountForUserUrl: "api/User/RemoveAccountForUser",
    ToggleUserStatusUrl: 'api/user/ToggleUserStatus',
    //GetAuditHistoryUrl: "api/User/GetAuditHistory/",
    ResetUserPasswordUrl: 'api/user/ResetUserPassword/',
    GetContactByContactIdUrl: "api/User/GetContactByContactId/",
    GetUserAccountsByEmailIdUrl: "api/User/GetUserAccountsByEmailId/",
    GetEditingUserDetails:"api/User/GetEditingUserDetailsByContactId/",
    UnlockUserUrl: "api/User/UnlockUser/",
    UpdateContactDetailsIfAdfsGuidExistsUrl: "api/User/UpdateContactDetailsIfAdfsGuidExists/",
    GetUserStatusByUserNames: "api/User/GetAdfsUsersStatusByUserNames",
    //GetAccountsHirerachyUrl: "api/user/GetAccountsHirerachy/",
    GetLoggedInUserInfoUrl: "api/user/GetLoggedInUserInfo",
    SetUserAction: "api/user/SetUserAction/",
    UpdateContactBasicInfoUrl: "api/User/UpdateContactBasicInfo",
    GetEnviromentVariables: "api/User/GetEnviromentVariables",
    SetUserManagementAppSettingUrl: "api/User/SetUserManagementAppSetting/"
}

export default apiUrls;